import { fetchAuthSession } from 'aws-amplify/auth'
import { Field, Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { BiLoaderAlt } from 'react-icons/bi'
import { FaCircleArrowRight } from 'react-icons/fa6'
import { IoIosCopy, IoMdCheckmark } from 'react-icons/io'
import { MdRefresh } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { API } from '../api'

export const CreateWebhook = () => {
  const navigate = useNavigate()

  const [copied, setCopied] = useState(false)
  const [testing, setTesting] = useState(false)
  const [status, setStatus] = useState(undefined)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false)
      }, 1000)
    }
  }, [copied])

  const handleSubmit = async (name: string, url: string, secret: string) => {
    if (!testing && !loading) {
      setLoading(true)
      await API(await fetchAuthSession()).post(
        '/webhook',
        secret.length > 0 ? { name, url, secret } : { name, url }
      )
      navigate(-1)
    }
  }

  const onTestClick = async (url: string, secret: string) => {
    if (!testing && !loading) {
      setTesting(true)
      setStatus(undefined)
      const { data } = await API(await fetchAuthSession()).post(
        '/webhook/test',
        secret.length > 0 ? { url, secret } : { url }
      )
      setStatus(data?.status)
      setTesting(false)
    }
  }

  return (
    <div className="w-full max-w-[688px]">
      <h3 className="mb-5">Create new subscription</h3>
      <Formik
        onSubmit={(props) =>
          handleSubmit(props['name'], props['url'], props['secret'])
        }
        initialValues={{ name: '', url: '', secret: '' }}
      >
        {(props) => (
          <Form>
            <label htmlFor="name" className="text-sm my-4 block">
              <div className="w-full">Webhook name</div>
              <Field
                type="text"
                id="name"
                name="name"
                className="w-full ircam-input"
              />
            </label>
            <label htmlFor="url" className="text-sm my-4 block">
              <div className="w-full">Callback URL</div>
              <Field
                type="text"
                id="url"
                name="url"
                className="w-full ircam-input"
              />
            </label>
            <div className="flex justify-between items-center gap-2">
              <button
                type="button"
                className={`bigBtn !text-white !m-0 !text-[16px] ${props.values['url'].length === 0 || loading || testing ? 'disabled' : ''}`}
                onClick={() =>
                  onTestClick(props.values['url'], props.values['secret'])
                }
              >
                {testing ? (
                  <BiLoaderAlt className="loadingIcon text-white" />
                ) : (
                  <FaCircleArrowRight />
                )}
                Test
              </button>
              <p
                className={
                  status === 'SUCCESS'
                    ? 'text-notification-ok-text'
                    : status === 'ERROR'
                      ? 'text-notification-ko-text'
                      : ''
                }
              >
                {status ?? ''}
              </p>
            </div>
            <label htmlFor="secret" className="text-sm my-4 block">
              <div className="w-full">Secret</div>
              <Field
                type="text"
                id="secret"
                name="secret"
                className="w-full ircam-input"
              />
            </label>
            <div className="flex justify-between gap-2">
              <button
                type="button"
                className={`bigBtn !text-white !m-0 !text-[16px] ${loading || testing ? 'disabled' : ''}`}
                onClick={() =>
                  !loading &&
                  !testing &&
                  props.setFieldValue('secret', uuidv4())
                }
              >
                <MdRefresh />
                Generate new secret
              </button>
              <button
                type="button"
                className={`bigBtn !text-white !m-0 !text-[16px] ${props.values['secret'].length === 0 ? 'disabled' : ''}`}
                onClick={() => {
                  navigator.clipboard.writeText(props.values['secret'])
                  setCopied(true)
                }}
              >
                {copied ? <IoMdCheckmark /> : <IoIosCopy />}
                Copy
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2 mt-8">
              <Link to={-1 as any} className={loading ? 'disabled' : ''}>
                <div
                  className="w-full button button-large button-light py-2 px-4"
                  aria-disabled={loading}
                >
                  <div className="button button-label text-center">Cancel</div>
                </div>
              </Link>
              <button
                type="submit"
                className="w-full button button-large button-dark py-2 px-4"
                disabled={
                  loading ||
                  props.values['name'].length === 0 ||
                  props.values['url'].length === 0
                }
              >
                <div className="button button-label">
                  {loading ? 'Loading...' : 'Save new subscription'}
                </div>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
